#import "../fragments/wf-field-fragment.graphql"

mutation UpdateField($input: FormFieldUpdateInput!) {
    formFieldUpdate(input: $input) {
        field {
            ...WfFieldFragment
        }
    }
}
